<script>
import Layout from '@layouts/main.vue'
import { mapState, mapActions } from 'vuex'
import { authComputed } from '@state/helpers'

export default {
  page: {
    title: 'Verify Email',
    meta: [{ name: 'description', content: '' }],
  },
  name: 'VerifyEmailView',
  components: { Layout },
  data() {
    return {
      key: this.$route.query.key,
    }
  },
  computed: {
    ...authComputed,
    ...mapState('signup', [
      'activationLoading',
      'activationCompleted',
      'activationError',
      'activationResponseMessage',
    ]),
  },
  created() {
    this.activateAccount(this.key)
  },
  methods: {
    ...mapActions('signup', ['activateAccount', 'clearActivationStatus']),
  },
}
</script>

<template>
  <Layout>
    <div v-show="!activationLoading" :class="$style.accountActivation">
      <div class="container !pb-44">
        <template v-if="activationCompleted" class="text-center">
          <h3 class="mb-6">{{ activationResponseMessage }}.</h3>
            <router-link
              :to="{ name: 'login' }"
              tag="button"
              type="primary"
              class="btn primary large">
            {{ loggedIn ? 'To Dashboard' : 'Sign In' }}
          </router-link>
        </template>

        <template v-else-if="activationError">
          <h3 class="my-2 font-medium"><i class="text-onvocado-red el-icon-warning"></i> {{ activationResponseMessage }}.</h3>
          <p class="text-xs text-onvocado-gray">Your confirmation link might be incorrect or have expired. <br/>Go
            to <strong>Profile -> Settings</strong> to resend a confirmation
            link.</p>
        </template>

        <template v-else>
          <h3 class="my-2 font-medium">We couldn't confirm your account.
            <i class="text-onvocado-red el-icon-warning"></i></h3>
          <p>Please contact support.</p>
        </template>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>

.accountActivation {
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 450px;
  height: calc(100vh - 90px);
  margin: auto;

  a {
    margin: 0 0 0 0;
  }
}
</style>
